export default "__VITE_ASSET__e6e720fe__"